import React from "react"
import { countries as countriesConstant } from "constants/countries"
import { useGetCountries } from "api/hooks/enum"
import CountryFlags from "../../../containers/studies/StudyReview/CountryFlags/CountryFlags"

const CountriesCellRenderer = ({ value }) => {
  const { data: countries = countriesConstant } = useGetCountries()

  const renderFlags = () => {
    const filteredCountries = value?.filter((item) => item)

    return (
      <CountryFlags
        countries={countries}
        countryCodes={filteredCountries}
      />
    )
  }

  return <div style={{ display: "flex", gap: 4 }}>{renderFlags()}</div>
}

export default CountriesCellRenderer
